import PropTypes from "prop-types";
import { getFormattedDate } from "helpers/getFormattedDate";
import StringCell from "tables/common/StringCell";

export default function CommonDateCell({ getValue }) {
  const value = getValue();

  if (!value) return null;

  return <StringCell value={getFormattedDate(value)} />;
}

CommonDateCell.propTypes = {
  getValue: PropTypes.func.isRequired,
};
